var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    {
      staticClass: "d-flex justify-center",
      attrs: { id: "main", "fill-height": "", fluid: "" },
    },
    [
      _c(
        "v-card",
        { staticClass: "pa-5", attrs: { width: "400px" } },
        [
          _c(
            "v-card-text",
            [
              _c("v-img", {
                staticClass: "mb-8",
                attrs: { src: require("@/assets/logo-milos-gscv.png") },
              }),
              _vm.errorMessage
                ? _c(
                    "v-alert",
                    {
                      staticClass: "ma-4",
                      attrs: { type: "error", dismissible: "" },
                    },
                    [_vm._v(" " + _vm._s(_vm.errorMessage) + " ")]
                  )
                : _vm._e(),
              _c(
                "v-form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.submit.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("v-text-field", {
                    attrs: {
                      label: "Username",
                      variant: "outlined",
                      density: "comfortable",
                    },
                    model: {
                      value: _vm.username,
                      callback: function ($$v) {
                        _vm.username = $$v
                      },
                      expression: "username",
                    },
                  }),
                  _c("v-text-field", {
                    attrs: {
                      label: "Password",
                      variant: "outlined",
                      density: "comfortable",
                      "append-icon": _vm.showPassword
                        ? "mdi-eye"
                        : "mdi-eye-off",
                      type: _vm.showPassword ? "text" : "password",
                    },
                    on: {
                      "click:append": function ($event) {
                        _vm.showPassword = !_vm.showPassword
                      },
                    },
                    model: {
                      value: _vm.password,
                      callback: function ($$v) {
                        _vm.password = $$v
                      },
                      expression: "password",
                    },
                  }),
                  _c(
                    "v-btn",
                    { attrs: { type: "submit", color: "primary", block: "" } },
                    [_vm._v(_vm._s(_vm.$t("label.login")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }